import { Skeleton, Typography } from '@mui/material';
import { useCatalogFilters } from '@/packages/courses/context/catalog-filters';
import type { FilterOption } from '@/packages/courses/types/schema';
import type { CatalogUrlKey } from '@/packages/courses/types/url-params';

interface HeaderTitleProps {
  loading?: boolean;
  totalCount?: number;
}

const getFilterTitle = (
  params: ReturnType<typeof useCatalogFilters>['params'],
  schema: ReturnType<typeof useCatalogFilters>['schema'],
  key: CatalogUrlKey
): string | undefined => {
  const values = params[key];
  if (!values?.length) return undefined;
  const item = schema.find((s) => 'id' in s && s.id === key);
  if (!item || !('options' in item) || !item.options) return values[0];
  const opt = (item.options as FilterOption[]).find(
    (o) => o.value === values[0]
  );
  return opt?.label ?? values[0];
};

export const HeaderTitle = ({
  loading = false,
  totalCount = 0,
}: HeaderTitleProps) => {
  const { params, schema } = useCatalogFilters();

  const title = (() => {
    if (params.terms?.length && params.terms[0]) return params.terms[0];
    if (params.free_courses?.length && params.free_courses[0] === 'true') {
      if (!params.knowledge_areas?.length && !params.course_types?.length) {
        return 'Cursos Gratuitos';
      }
    }
    const courseTypesLabel = getFilterTitle(params, schema, 'course_types');
    if (courseTypesLabel && !params.knowledge_areas?.length)
      return courseTypesLabel;
    const knowledgeLabel = getFilterTitle(params, schema, 'knowledge_areas');
    if (knowledgeLabel && !params.course_types?.length) return knowledgeLabel;
    const institutionLabel = getFilterTitle(params, schema, 'institutions');
    if (institutionLabel) return institutionLabel;
    return 'Resultados da busca';
  })();

  return (
    <>
      <Typography variant="h3" color="text.secondary" component="span" mr={1}>
        {title}
      </Typography>
      <Typography component="span" variant="body1" color="text.secondary">
        {loading ? (
          <Skeleton
            animation="wave"
            width={60}
            sx={{ display: 'inline-block', verticalAlign: 'middle' }}
          />
        ) : (
          `${totalCount} resultados`
        )}
      </Typography>
    </>
  );
};
